document.addEventListener('DOMContentLoaded', function () {
  const accordions = document.querySelectorAll('.section-accordion');

  accordions.forEach(function (accordion) {
    initializeAccordion(accordion);
  });
});

function initializeAccordion(accordion) {
  if (accordion.dataset.initialized) return; // prevent double init
  accordion.dataset.initialized = 'true';

  const items = accordion.querySelectorAll('.accordion__item');
  let activeItem = null;

  // Initialize items
  items.forEach(item => {
    const content = item.querySelector('.accordion__content');
    const button = item.querySelector('.accordion__button');

    content.style.maxHeight = '0px';
    content.style.overflow = 'hidden';
    button.setAttribute('aria-expanded', 'false');
  });

  // ✅ ONE click listener per accordion
  accordion.addEventListener('click', function (e) {
    const button = e.target.closest('.accordion__button');
    if (!button) return;

    e.preventDefault();

    const item = button.closest('.accordion__item');
    toggleItem(item);
  });

  function toggleItem(item) {
    const button = item.querySelector('.accordion__button');
    const content = item.querySelector('.accordion__content');
    const isExpanded = button.getAttribute('aria-expanded') === 'true';

    // Close active item
    if (activeItem && activeItem !== item) {
      const activeButton = activeItem.querySelector('.accordion__button');
      const activeContent = activeItem.querySelector('.accordion__content');

      activeButton.setAttribute('aria-expanded', 'false');
      activeContent.style.maxHeight = '0px';
      activeItem.classList.remove('active');
    }

    if (!isExpanded) {
      button.setAttribute('aria-expanded', 'true');
      content.style.maxHeight = content.scrollHeight + 'px';
      item.classList.add('active');
      activeItem = item;

      // Scroll into view
      setTimeout(() => {
        const rect = content.getBoundingClientRect();
        const isInViewport =
          rect.top >= 0 && rect.bottom <= window.innerHeight;

        if (!isInViewport) {
          const headerOffset = 100;
          const offsetPosition =
            rect.top + window.pageYOffset - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 300);
    } else {
      button.setAttribute('aria-expanded', 'false');
      content.style.maxHeight = '0px';
      item.classList.remove('active');
      activeItem = null;
    }
  }

  // Resize handler
  let resizeTimeout;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function () {
      if (activeItem) {
        const content = activeItem.querySelector('.accordion__content');
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    }, 250);
  });
}
